import styled from 'styled-components'
import { Swiper } from 'swiper/react'
import { device, fonts, size } from '../../../styles/GlobalVariables'
import PlayIcon from './Pointing.svg'

interface StyledSwiperScrollPrevProps {
  disabled?: boolean
}

interface StyledSwiperScrollNextProps {
  disabled?: boolean
}

export const MainRailWrap = styled.div`
  position: relative;
  overflow: visible;
  margin-bottom: -16vw;

  @media only screen and (max-width: 768px) {
    height: calc(100vw * 1.12);
    margin-bottom: 26vw;
  }

  ${device.small} {
    height: calc(100vw * 9 / 16);
  }

  @media only screen and (max-width: 1440px) and (min-width: 768px) {
    margin-bottom: -10vw;
  }
`

export const Title = styled.div`
  @media only screen and (max-width: 768px) {
    color: #fff;
    text-align: center;
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -1.04px;
    z-index: 1;
  }
`

interface StyledNavBuProps {
  type?: string
}

interface StyledLiveButtonProps {
  display?: 'true'
}

export const RailTitle = styled.div`
  text-align: right;
  font-family: ${fonts.default};
  margin-bottom: 1vw;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;

  @media only screen and (max-width: 768px) {
    font-size: 5.75vw;
    margin-bottom: 4vw;
  }
`
export const ButtonWrap = styled.div`
  display: flex;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`
export const SwiperScrollNext = styled.div<StyledSwiperScrollNextProps>`
  cursor: pointer;
  z-index: 100;
  width: 4.41vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: -5.7vw;
  display: ${props => (props.disabled ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 768px) {
    display: none;
  }

  &:hover {
    div:first-child {
      opacity: 0.8;
    }

    div.ArrowDiv {
      transform: translate(-50%, -50%) scale(1.1);
    }
  }
`
export const SwiperScrollPrev = styled.div<StyledSwiperScrollPrevProps>`
  cursor: pointer;
  z-index: 100;
  width: 4.41vw;
  height: 100%;
  position: absolute;
  top: 0;
  right: -5.7vw;
  display: ${props => (props.disabled ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 768px) {
    display: none;
  }

  &:hover {
    div.ArrowDiv {
      transform: translate(-50%, -50%) scale(1.1);
    }
`
export const ArrowDiv = styled.div<StyledNavBuProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease;
  content: ${props =>
    props.type === 'next'
      ? "url('https://media3.reshet.tv/image/upload/v1707812820/dev-uploads/2024/862016.webp')"
      : "url('https://media3.reshet.tv/image/upload/v1707812812/dev-uploads/2024/862015.webp')"};
  background-repeat: no-repeat;
`
export const RailBackground = styled.div<{
  mobileImage: string
  desktopImage: string
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 85%;
  height: 100%;
  background-image: url(${props => props.desktopImage});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;

  @media only screen and (max-width: 768px) {
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }

  @media only screen and (max-width: 768px) {
    background-image: url(${props => props.mobileImage});
    background-size: cover;

    &:before {
      right: -15px;
      background: linear-gradient(
          to top,
          rgba(12, 15, 31, 1) 0%,
          rgba(12, 15, 31, 1) 10%,
          rgba(6, 6, 13, 0) 55%
        ),
        linear-gradient(to left, rgba(12, 15, 31, 1) 3%, rgba(6, 6, 89, 0) 10%);
    }

    > :first-child {
      text-align: center;
      font-size: 6vw;
      letter-spacing: -0.96px;
      margin: inherit;
    }
  }
`
export const WatchButton = styled.button`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  padding: 1vw 2.42vw;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 1.4vw;
  font-weight: 500;
  color: #000;
  border-radius: 59px;
  background: #fffdfd;
  border: none;
  cursor: pointer;
  z-index: 1;
  position: relative;

  &:hover {
    background: #fffdfd;
    opacity: 0.9;
  }

  @media only screen and (max-width: 768px) {
    padding: 4.5vw 9.3vw;
    font-size: 22px;
    width: 173px;
    height: 66px;
    font-weight: 500;
  }
`

export const PointingTriangle = styled(PlayIcon)`
  margin-left: 0.5vw;
  font-size: 0.95vw;

  @media only screen and (max-width: 768px) {
    margin-left: 2vw;
    width: 17px;
    height: 15px;
  }
`
export const CustomSwiper = styled(Swiper)`
  overflow: visible;

  ${device.small} {
    overflow: visible;
  }

  .swiper-slide {
    &.swiper-slide-visible {
      opacity: 1;
    }
  }
`
export const CustomPosterSwiper = styled(Swiper)`
  overflow: visible;
  @media only screen and (min-width: 768px) {
    .swiper-slide {
      opacity: 0.4;

      &.swiper-slide-visible {
        opacity: 1;
      }
    }
  }
`
export const MainSwiperWrapper = styled.div`
  height: 0;
  overflow: visible;
  width: 100%;
  position: relative;
  z-index: 3;
  margin-top: 40px;

  ${device.small} {
    bottom: 27.8vw;
    position: absolute;
  }

  @media only screen and (max-width: 768px) {
    //bottom: 15%;
  }
`
export const DeskBackgroundContent = styled.div<StyledLiveButtonProps>`
  position: relative;
  width: ${props => (props.display ? '100%' : '22%')};
  display: flex;
  gap: 1.6vw;
  flex-direction: column;
  align-items: center;
  color: white;

  ${device.small} {
    display: ${props => (props.display ? 'none' : 'flex')};
    align-items: flex-start;
    color: #fff;
    text-align: right;
    font-size: 2.5vw;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.1vw;
    top: 16vh;
    right: 6vw;
    z-index: 1;
  }

  @media only screen and (max-width: 768px) {
    display: ${props => (props.display ? 'flex' : 'none')};
    gap: ${props => (props.display ? '3vw' : '1.6vw')};
    top: 0;
    left: 0;
    height: 89%;
    width: 100%;
    justify-content: flex-end;
  }
`
export const MainPanelWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: 768px) {
    display: block;
    height: 100%;
  }
`

export const MainPageBackgroundGradient = styled.div`
  width: 100%;
  position: absolute;
  z-index: 1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 23.86%,
    #000 89.91%,
    rgba(0, 0, 0, 0) 100%
  );

  ${device.small} {
    height: 100%;
    background-position: top right;
    background-size: cover;
    background-image: url(https://media3.reshet.tv/image/upload/q_auto:best/v1710237318/ott/Full_Gradiant-1_1.webp);
  }

  @media only screen and (max-width: 768px) {
    height: 115%;
  }
`

export const ArrowDivBG = styled.div<StyledNavBuProps>`
  opacity: 0.7;
  border-radius: ${props =>
    props.type === 'next' ? '0 8px 8px 0' : '8px 0 0 8px'};
  background-color: #02061b;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`
export const CustomMainRail = styled.div<{ opacity: 0 | 1 }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  gap: 25px;
  transition: opacity 200ms ease-in;
  opacity: ${props => props.opacity};

  @media only screen and (min-width: ${size.small}px) and (max-width: 1280px) {
    gap: 1.5vw;

    > div {
      max-width: 20vw;
    }
  }
`
